import {HttpRequest,HttpMethod} from "./http";

class ProductCategoryProvider extends HttpRequest {

	// CRUD Product	
	ProductCategoryCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/products/category`,params );
	}

	ProductCategoryList(params) {
		return this.request(HttpMethod.Get,`/api/v1/products/category`,params );
	}

	ProductCategoryUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/products/category/${id}`,params );
	}

	ProductCategoryDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/products/category/${id}`);
	}


}

export default ProductCategoryProvider